import { ChangeDetectionStrategy, Component, computed, input, ViewEncapsulation } from '@angular/core';
import { Color, LegendPosition, ScaleType } from '@swimlane/ngx-charts';
import { CoreComponent } from 'lib/ui/core/core.component.js';
import { graphHelper } from '../graph.helper.js';
import { GraphLegendPosition, ISingleSeries } from '../graph.models.js';

@Component({
	selector: 'lib-pie-chart',
	templateUrl: './pie-chart.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	styleUrls: ['../graphs.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: false
})
export class PieChartComponent extends CoreComponent {
	public readonly singleSeries = input.required<readonly ISingleSeries[]>();
	public readonly colorScheme = input<readonly string[]>();
	public readonly view = input<[number, number]>([0, 0]);
	public readonly gradient = input<boolean>(false);
	public readonly showLabels = input<boolean>(true);
	public readonly isDoughnut = input<boolean>(false);
	public readonly legendPosition = input<GraphLegendPosition>('right');
	public readonly tooltipDisabled = graphHelper.isTooltipDisabled;

	public readonly showLegend = computed<boolean>(() => {
		// do not show legend because it's not positioned correctly
		return false;
	});

	public readonly colorsDomain = computed<Color>(() => {
		const colorScheme = this.colorScheme();

		if (!colorScheme) {
			return graphHelper.getDefaultColorScheme();
		}

		const color: Color = {
			domain: Array.from(colorScheme),
			group: ScaleType.Linear,
			name: '',
			selectable: false
		};

		return color;
	});

	public readonly legendPositionCalculated = computed<LegendPosition>(() => {
		return this.legendPosition() === 'right' ? LegendPosition.Right : LegendPosition.Below;
	});

	constructor() {
		super();
	}
}
